import { createTheme, ThemeProvider } from "@mui/material/styles";
import Onbording from "./components/onbording/Onbording";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CurrentPortfolio from "./components/currentPortfolio/CurrentPortfolio";
import Introduction from "./components/monthlyIncome/Introduction";
import FinanacialQuestion from "./components/monthlyIncome/FinanacialQuestion";
import Goal from "./components/goal/Goal";
import ChildPlanningQuestion from "./components/childPlanning/ChildPlanningQuestion";
import DependantQuestion from "./components/childPlanning/DependantQuestion";
import RetirementGoal from "./components/futurePlanning/retirement/RetirementGoal";
import InfoFetch from "./components/accountAggregator/InfoFetch";
import InvestmentGoal from "./components/futurePlanning/investment/InvestmentGoal";
import YourLiabilities from "./components/accountAggregator/YourLiabilities";
import ThnakYouPage from "./components/accountAggregator/ThnakYouPage";
import FinancialSnapshot from "./components/dashboard/FinancialSnapshot";
import Dashboard from "./components/dashboard/Dashboard";
import { CssBaseline } from "@mui/material";
import AuthProvider from "./Hooks/context/AuthContext";
import ChildQuestion from "./components/childPlanning/ChildQuestion";
import DataProvider from "./Hooks/context/ChildData";
import { ReloadProvider } from "./Hooks/context/RealodContext";
import EditFlagProvider from "./Hooks/context/EditFlagContext";
import AgentDashboard from "./components/dashboard/agentDashboard/AgentDashboard";
import ChildEducationMarriage from "./components/childPlanning/ChildEducationMarriage";
import AgentDataProvider from "./Hooks/context/AgentData";
import OTPVerifyProvider from "./Hooks/context/OTPVeriryContext";
import AccountAagregatorProvider from "./Hooks/context/AccountAaggregator";
import { useEffect } from "react";
import WebViewComponent from "./components/accountAggregator/WebViewComponent";
import FinancialDetailsProvider from "./Hooks/context/FinancialDetails";
import { String } from "./constants/Strings";
import usePageTracking from "./Hooks/CustomHooks/usePageTracking";

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          padding:
            "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
        },
      },
    },
  },
});
export const Urls = () => {
  let urls = { baseURL: "", APIKey: "" };
  if (window.location.origin.includes("https://acrdev.axismaxlife.com")) {
    urls.baseURL = "https://devapi.maxlifeinsurance.com/acr";
    urls.APIKey = "U1HQLHNvZO8ewIKnaZEIv95fvF4zDfEu3h9aLuAI";
  } else if (
    window.location.origin.includes("https://acruat.axismaxlife.com")
  ) {
    urls.baseURL = "https://uatapi.maxlifeinsurance.com/acr";
    urls.APIKey = "aDOZwp6VeM74RDuuQFgpRVZAoVdjul5Dppz2Oh30";
  } else if (
    window.location.origin.includes("https://acr.axismaxlife.com") ||
    window.location.origin.includes("d39o2i5c09o8rd.cloudfront.net")
  ) {
    urls.baseURL = "https://api.maxlifeinsurance.com/acr";
    urls.APIKey = "CvMjxeXTUc7sa8BsPC3VtaMPcbEQ6Auq8AKrf44B";
  } else {
    urls.baseURL = "https://devapi.maxlifeinsurance.com/acr";
    urls.APIKey = "U1HQLHNvZO8ewIKnaZEIv95fvF4zDfEu3h9aLuAI";
  }
  return urls;
};

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ReloadProvider>
      <AuthProvider>
        <DataProvider>
          <FinancialDetailsProvider>
            <AccountAagregatorProvider>
              <AgentDataProvider>
                <OTPVerifyProvider>
                  <EditFlagProvider>
                    <ThemeProvider theme={theme}>
                      <CssBaseline />
                      <Router>
                        <PageTrackerWrapper />
                        <Routes>
                          <Route
                            path={String.navigations.initiate}
                            element={<Onbording />}
                          ></Route>
                          <Route
                            path={String.navigations.currentportfolio}
                            element={<CurrentPortfolio />}
                          ></Route>
                          <Route
                            path={String.navigations.monthlyincomeintroduction}
                            element={<Introduction />}
                          />
                          <Route
                            path={String.navigations.financialquestion}
                            element={<FinanacialQuestion />}
                          />
                          <Route
                            path={String.navigations.goal}
                            element={<Goal />}
                          />
                          <Route
                            path={String.navigations.childplanning}
                            element={<ChildPlanningQuestion />}
                          />
                          <Route
                            path={String.navigations.childquestion}
                            element={<ChildQuestion />}
                          />
                          <Route
                            path={String.navigations.dependantquestion}
                            element={<DependantQuestion />}
                          />
                          <Route
                            path={String.navigations.childeducationmarriage}
                            element={<ChildEducationMarriage />}
                          />

                          <Route
                            path={String.navigations.retirementgoal}
                            element={<RetirementGoal />}
                          ></Route>
                          <Route
                            path={String.navigations.investmentgoal}
                            element={<InvestmentGoal />}
                          />
                          <Route
                            path={String.navigations.fetchinfo}
                            element={<InfoFetch />}
                          />
                          <Route
                            path={String.navigations.webview}
                            element={<WebViewComponent />}
                          />
                          <Route
                            path="cibilscore"
                            element={<YourLiabilities />}
                          />
                          <Route path="thankyou" element={<ThnakYouPage />} />
                          <Route
                            path={String.navigations.financialsnapshot}
                            element={<FinancialSnapshot />}
                          />
                          <Route
                            path={String.navigations.customerdashboard}
                            element={<Dashboard />}
                          />
                          <Route
                            path={String.navigations.dashboard}
                            element={<AgentDashboard />}
                          />
                        </Routes>
                      </Router>
                    </ThemeProvider>
                  </EditFlagProvider>
                </OTPVerifyProvider>
              </AgentDataProvider>
            </AccountAagregatorProvider>
          </FinancialDetailsProvider>
        </DataProvider>
      </AuthProvider>
    </ReloadProvider>
  );
}

export default App;


const PageTrackerWrapper = () => {
  usePageTracking();
  return null;
};